import CryptoJS from 'crypto-js'

export default {
  encode: function (value) {
    const data = JSON.stringify(value)
    const hash = CryptoJS.AES.encrypt(data, process.env.VUE_APP_HASH_KEY).toString()
    return hash
  },
  decode: function (hash) {
    const result = JSON.parse(CryptoJS.AES.decrypt(hash, process.env.VUE_APP_HASH_KEY).toString(CryptoJS.enc.Utf8))
    return result
  }
}
